import ShowDetailsScreen from './ShowDetailsScreen'

export default ShowDetailsScreen
